export enum PostOrderDisplayMode {
  Status = 'status',
  Custom = 'custom',
  StatusCustom = 'status_custom',
  CallByNumber = 'call_by_number',
  CallByName = 'call_by_name',
}
